// components/industry-templates/CryptoEventTemplate.tsx
import { Card, CardContent, CardHeader, CardTitle } from '@/components/ui/card';
import { Badge } from '@/components/ui/badge';
import { Bitcoin, TrendingUp, Users, Zap } from 'lucide-react';

export const CryptoEventTemplate = ({ structure, theme }: any) => {
  const industryData = structure.industry_data;

  return (
    <div className="space-y-8">
      <Card className="border-0 bg-gradient-to-br from-orange-500/20 to-yellow-500/20 backdrop-blur">
        <CardHeader>
          <CardTitle className="text-white flex items-center gap-2 text-2xl">
            <Bitcoin className="w-8 h-8" style={{ color: theme.primary }} />
            Blockchain & Crypto Topics
          </CardTitle>
        </CardHeader>
        <CardContent>
          <div className="grid grid-cols-2 md:grid-cols-3 gap-4">
            {industryData?.topics?.map((topic: string, idx: number) => (
              <div key={idx} className="p-5 bg-white/10 rounded-xl border border-white/20 hover:scale-105 transition-transform">
                <div className="text-3xl mb-2">₿</div>
                <p className="text-white font-bold">{topic}</p>
              </div>
            ))}
          </div>
        </CardContent>
      </Card>

      {industryData?.nft_exhibition && (
        <Card className="border-2" style={{ borderColor: theme.primary, backgroundColor: 'rgba(249, 115, 22, 0.1)' }}>
          <CardHeader>
            <CardTitle className="text-white flex items-center gap-2">
              <Zap className="w-6 h-6" style={{ color: theme.primary }} />
              NFT Exhibition
            </CardTitle>
          </CardHeader>
          <CardContent>
            <div className="bg-white/5 rounded-lg p-6 text-center">
              <p className="text-3xl font-bold mb-2" style={{ color: theme.primary }}>
                {industryData.nft_exhibition.collections}+ Collections
              </p>
              <p className="text-white">Exclusive NFT drops and live minting</p>
            </div>
          </CardContent>
        </Card>
      )}

      {industryData?.speakers && (
        <Card className="border border-white/10 bg-slate-900/50 backdrop-blur">
          <CardHeader>
            <CardTitle className="text-white flex items-center gap-2">
              <Users className="w-6 h-6" style={{ color: theme.primary }} />
              Industry Leaders
            </CardTitle>
          </CardHeader>
          <CardContent>
            <div className="space-y-3">
              {industryData.speakers.map((speaker: any, idx: number) => (
                <div key={idx} className="p-4 bg-white/5 rounded-lg flex items-center gap-4">
                  <div className="text-3xl">🚀</div>
                  <div>
                    <h4 className="font-bold text-white">{speaker.name}</h4>
                    <p className="text-sm text-slate-400">{speaker.company}</p>
                  </div>
                </div>
              ))}
            </div>
          </CardContent>
        </Card>
      )}
    </div>
  );
};
